module.exports = __webpack_public_path__ + "img/rascrut-9.2dc1e00c.jpg";